import React, { useEffect, useState } from 'react';
import { Modal, Form, Select, Alert, message } from 'antd';
import session from '../../../utils/session';
import { sendTestEmailRule } from '../api';
import { emailTypeLabel } from '../emailRecipientTypes';

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const emailListValidator = (_rule, value) => {
    if (!value || value.length === 0) return Promise.reject(new Error('Add at least one recipient'));
    const bad = value.filter((v) => !EMAIL_RE.test((v || '').trim()));
    if (bad.length) return Promise.reject(new Error(`Invalid email${bad.length > 1 ? 's' : ''}: ${bad.join(', ')}`));
    return Promise.resolve();
};

const SendTestEmailModal = ({ open, rule, companyId, onClose }) => {
    const [form] = Form.useForm();
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        if (open) {
            const userData = session.get('userData') || {};
            const own = userData.email || userData.username;
            form.setFieldsValue({ to: own && EMAIL_RE.test(own) ? [own] : [] });
        }
    }, [open, form]);

    const handleSend = async () => {
        try {
            const values = await form.validateFields();
            setSubmitting(true);
            const res = await sendTestEmailRule(companyId, rule.email_type, { to: values.to });
            const { cc = [], bcc = [] } = res.data || {};
            const extras = [
                cc.length ? `CC: ${cc.join(', ')}` : null,
                bcc.length ? `BCC: ${bcc.join(', ')}` : null,
            ].filter(Boolean).join(' · ');
            message.success(`Test sent to ${values.to.join(', ')}${extras ? ` (${extras})` : ''}`);
            onClose();
        } catch (err) {
            if (err.errorFields) return;
            message.error(err.message || 'Failed to send test email');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Modal
            title={rule ? `Send test — ${emailTypeLabel(rule.email_type)}` : 'Send test email'}
            open={open}
            onCancel={onClose}
            onOk={handleSend}
            okText="Send test"
            confirmLoading={submitting}
            destroyOnClose
            width={480}
        >
            <Form form={form} layout="vertical">
                <Form.Item
                    name="to"
                    label="Send test to"
                    rules={[{ validator: emailListValidator }]}
                >
                    <Select
                        mode="tags"
                        tokenSeparators={[',', ' ']}
                        open={false}
                        style={{ width: '100%' }}
                        placeholder="Recipient email(s)"
                    />
                </Form.Item>
                <Alert
                    type="info"
                    showIcon
                    message="The test uses sample data. It is sent To the address above and also CC/BCCs the recipients configured for this email type."
                />
            </Form>
        </Modal>
    );
};

export default SendTestEmailModal;
